import PropTypes from 'prop-types';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

function BreadCrumbsOutrightLabelUI({ categoryName }) {
  return <FormattedMessage id="breadcrumbs.outrights" values={{ categoryName }} />;
}

BreadCrumbsOutrightLabelUI.propTypes = {
  categoryName: PropTypes.string.isRequired,
};

export const BreadCrumbsOutrightLabel = memo(BreadCrumbsOutrightLabelUI);
